import type {SnackbarKey} from "notistack";
import type {EnqueueSnackbar} from "../ui/hooks/useNotification";

export interface SnackBarRef {
    current: {
        enqueueSnackbar: EnqueueSnackbar,
        closeSnackbar: (key?: SnackbarKey) => void,
    } | null;
}

export const snackBarRef: SnackBarRef = {
    current: null
};
